import React, { useEffect, useState } from "react";
import { ITreatment } from "../types/clinic.types";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import baseUrl from "../../../../api/baseUrl";

interface Props {
  treatment: ITreatment | null; // null for 'Add', object for 'Edit'
  onClose: () => void;
  onSave: (treatment: ITreatment) => void;
}
interface Data {
  id: number | string;
  name: string;
  calories: string;
}

function createData(id: number | string, name: string, calories: string): Data {
  return { id, name, calories };
}
const DEFAULT_TREATMENT: Omit<ITreatment, "id" | "subTreatments"> = {
  treatmentId: "",
  localPrice: "",
  foreginPrice: "",
};

export const TreatmentFormModal: React.FC<Props> = ({
  treatment,
  onClose,
  onSave,
}) => {
  const [formData, setFormData] = useState(treatment || DEFAULT_TREATMENT);
  const isEditMode = !!treatment;
  console.log(treatment);
  
  const [rows, setRows] = useState<Data[]>([]);
  useEffect(() => {
    baseUrl
      .get("/client/booking/findBookClinicTreatment")
      .then((response: any) => {
        console.log(response.data.data);
        const formattedRows = response.data.data.map((item: any) =>
          createData(item._id, item.name, item.decription)
        );
        setRows(formattedRows);
      })
      .catch(console.error);
  }, []);
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "number" ? parseFloat(value) || 0 : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
   console.log(treatment);
   
    if (isEditMode) {
      baseUrl
        .patch("/client/booking/updateBookTreatments", formData)
        .then((response) => {
          onSave(formData as ITreatment);
        })
        .catch((error) => {
          if (error.response?.status === 409) {
            alert("A treatment  already exists.");
          } else {
            console.error(error);
            alert("An unexpected error occurred.");
          }
        })
        .finally(() => {});
    } else { const errors = [];
    if (!formData.treatmentId) errors.push("Treatment is required.");
    if (
      !formData.localPrice ||
      isNaN(Number(formData.localPrice)) ||
      Number(formData.localPrice) < 0
    )
      errors.push("Local price must be a valid non-negative number.");
    if (
      !formData.foreginPrice ||
      isNaN(Number(formData.foreginPrice)) ||
      Number(formData.foreginPrice) < 0
    )
      errors.push("Foreign price must be a valid non-negative number.");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }

    const payload = {
      ...formData,
      localPrice: Number(formData.localPrice),
      foreginPrice: Number(formData.foreginPrice),
    };
      baseUrl
        .patch("/client/booking/createBookTreatments", payload)
        .then((response) => {
          onSave(formData as ITreatment);
        })
        .catch((error) => {
          if (error.response?.status === 409) {
            alert("A treatment  already exists.");
          } else {
            console.error(error);
            alert("An unexpected error occurred.");
          }
        })
        .finally(() => {});
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[1000] p-4">
      <div
        className="bg-white rounded-[8px] shadow-2xl max-w-[500px] w-full p-3 relative max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={handleSubmit}>
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-xs font-bold text-slate-800 mb-0">{isEditMode ? "Edit Treatment" : "Add New Treatment"}</h3>
            <button
              type="button"
              className="p-1.5 text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-full transition-colors"
              onClick={onClose}
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </button>
          </div>
          <div className="space-y-3">
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1">Treatment Name</label>
              <select
                name="treatmentId"
                value={formData.treatmentId}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all text-xs text-slate-700"
              >
                 <option value={""}>
                    select
                  </option>
                {rows.map((row) => (
                  <option key={row.id} value={row.id}>
                    {row.name + " - " + (row?.calories ?? "")}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1">Consulting Normal Price LKR</label>
              <input
                type="number"
                name="localPrice"
                value={formData.localPrice}
                onChange={handleChange}
                placeholder="Enter price in LKR"
                className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all text-xs text-slate-700"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1">Consulting Price for Foreigners USD</label>
              <input
                type="number"
                name="foreginPrice"
                value={formData.foreginPrice}
                onChange={handleChange}
                placeholder="Enter price in USD"
                className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all text-xs text-slate-700"
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-3">
            <button type="button" className="px-4 py-2.5 bg-slate-100 text-slate-700 rounded-lg font-medium hover:bg-slate-200 transition-colors text-xs" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="flex items-center gap-1.5 px-4 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs">
              <SaveAltIcon sx={{ fontSize: 16 }} />
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
